import React from 'react';
import { round } from '../..';
import { BaseLabel } from '../base-label';
import { reverseRotateTransform } from '../reverse-rotate';
export const Label = ({ x = 0, y = 0, width, height, children, angle = 0, color, fontSize, className }) => (React.createElement("svg", { className: className, x: x, y: y, width: width, height: height },
    React.createElement(BaseLabel, { color: color, fontSize: fontSize, transform: angle ? reverseRotateTransform(round(width / 2), round(height / 2), angle) : undefined }, children)));
//# sourceMappingURL=label.js.map